// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../components/LoginModal.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import original modal variables and utility styles */

/* Remove default animation scale translate so it sits perfectly */
@keyframes cardSlideIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Outer wrapper takes full viewport */
.auth-page-wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  background-color: #020617;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.auth-page-wrapper .hyperspeed-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

/* Auth card covers the whole page */
.auth-page-card-container {
  position: relative;
  width: 100% !important;
  max-width: none !important;
  height: 100% !important;
  margin: 0 !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  z-index: 10;
  background: transparent !important;
  backdrop-filter: none !important;
}

/* Stretched inner container */
.auth-page-card-container .auth-container {
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  height: 100% !important;
  width: 100% !important;
}

/* Left panel height and styling */
.auth-page-card-container .auth-left-panel {
  width: 50% !important; /* Exact half width */
  height: 100% !important;
  border-radius: 0 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.05);
}

.auth-brand-heading-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 1.5rem;
}

.auth-brand-heading-wrapper::before {
  content: '';
  position: absolute;
  top: 15%;
  left: 10%;
  right: 10%;
  bottom: 15%;
  background: linear-gradient(135deg, #6366f1, #a855f7, #ec4899);
  filter: blur(35px);
  opacity: 0.16;
  z-index: -1;
  border-radius: 50%;
  animation: auraPulse 6s ease-in-out infinite alternate;
  pointer-events: none;
}

.auth-brand-heading {
  font-family: 'Outfit', sans-serif !important;
  font-size: 3.8rem !important;
  font-weight: 800 !important;
  line-height: 1.15 !important;
  letter-spacing: -0.03em !important;
  background: transparent !important; /* Clear background block completely */
  text-shadow: 0 4px 20px rgba(99, 102, 241, 0.15) !important;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important; /* Elastic transition bounce */
  animation: floatBrandText 5s ease-in-out infinite alternate !important;
  display: inline-block !important; /* Enable transform/scale features */
}

.bounce-letter {
  display: inline-block !important;
  background: linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%) !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  opacity: 0;
  transform: translateX(-25px) scale(0.85);
  animation: letterEmerge 0.65s cubic-bezier(0.25, 1, 0.5, 1) forwards !important;
}

.auth-brand-heading:hover {
  transform: scale(1.08) translateY(-4px) !important;
  filter: brightness(1.25) !important;
  text-shadow: 
    0 10px 30px rgba(168, 85, 247, 0.45), 
    0 0 50px rgba(99, 102, 241, 0.25) !important;
  cursor: default;
}

@keyframes letterEmerge {
  0% {
    opacity: 0;
    transform: translateX(-25px) scale(0.85);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes floatBrandText {
  0% {
    transform: translateY(0) rotate(-1deg);
  }
  100% {
    transform: translateY(-8px) rotate(1deg);
  }
}

@keyframes textGradientFlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes auraPulse {
  0% {
    transform: scale(0.9) rotate(0deg);
    opacity: 0.16;
    filter: blur(30px);
  }
  100% {
    transform: scale(1.2) rotate(185deg);
    opacity: 0.28;
    filter: blur(45px);
  }
}

/* Right panel height and styling */
.auth-page-card-container .auth-right-panel {
  width: 50% !important; /* Exact half width */
  height: 100% !important;
  border-radius: 0 !important;
  padding: 6rem 6rem; /* Top/bottom padding provides natural spacing */
  display: flex;
  flex-direction: column;
  justify-content: flex-start !important; /* Prevent Flexbox center-scroll cutoff */
  overflow-y: auto !important; /* Enable scrolling */
}

.auth-back-btn {
  position: absolute;
  top: 30px;
  left: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.85);
  width: 42px;
  height: 42px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10005;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.auth-back-btn:hover {
  background: rgba(15, 23, 42, 0.9);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateX(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

/* Ensure inside items stretch and align correctly */
.auth-page-card-container .auth-container {
  border: none;
  background: transparent;
}

/* Custom responsiveness if height needs adjustments */
@media (max-width: 900px) {
  .auth-page-wrapper {
    overflow-y: auto;
    height: auto;
    min-height: 100vh;
  }
  .auth-page-card-container {
    height: auto !important;
  }
  .auth-page-card-container .auth-container {
    flex-direction: column;
    height: auto !important;
  }
  .auth-page-card-container .auth-left-panel {
    width: 100% !important;
    height: auto !important;
    padding: 6rem 2rem 3rem;
  }
  .auth-page-card-container .auth-right-panel {
    width: 100% !important;
    height: auto !important;
    padding: 3rem 2rem;
  }
  .auth-back-btn {
    top: 20px;
    left: 20px;
  }
}

/* Floating Cloud Logos styling & keyframes */
.auth-page-card-container .auth-left-panel {
  position: relative !important;
  overflow: hidden !important;
}

.floating-logo {
  position: absolute;
  pointer-events: none;
  z-index: 1;
}

.floating-logo img {
  display: block;
}

/* AWS Logo: Top Left */
.float-aws {
  top: 10%;
  left: 8%;
  animation: floatAWS 22s infinite ease-in-out alternate;
}

.float-aws img {
  width: 100px; /* Optically sized width */
  filter: invert(1) hue-rotate(180deg) brightness(1.25) opacity(0.55) drop-shadow(0 0 35px rgba(255, 153, 0, 0.7));
}

@keyframes floatAWS {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(8vw, 6vh) rotate(8deg);
  }
  100% {
    transform: translate(-2vw, 12vh) rotate(-8deg);
  }
}

/* Azure Logo: Middle Right */
.float-azure {
  top: 38%;
  right: 6%;
  animation: floatAzure 26s infinite ease-in-out alternate;
}

.float-azure img {
  width: 65px; /* Optically sized width for square block */
  filter: brightness(1.2) opacity(0.55) drop-shadow(0 0 35px rgba(0, 120, 215, 0.7));
}

@keyframes floatAzure {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(-8vw, 8vh) rotate(12deg);
  }
  100% {
    transform: translate(-3vw, -8vh) rotate(-12deg);
  }
}

/* GCP Logo: Bottom Left */
.float-gcp {
  bottom: 12%;
  left: 10%;
  animation: floatGCP 24s infinite ease-in-out alternate;
}

.float-gcp img {
  width: 85px; /* Optically sized width */
  filter: brightness(1.2) opacity(0.55) drop-shadow(0 0 35px rgba(66, 133, 244, 0.7));
}

@keyframes floatGCP {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(8vw, -6vh) rotate(-10deg);
  }
  100% {
    transform: translate(-2vw, -12vh) rotate(8deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuthPage.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAGvD,kEAAkE;AAClE;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;EACzB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,WAAW;EACX,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,qBAAqB,EAAE,qBAAqB;EAC5C,uBAAuB;EACvB,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,8DAA8D;EAC9D,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,sDAAsD;EACtD,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,kCAAkC,EAAE,sCAAsC;EAC1E,2DAA2D;EAC3D,uEAAuE,EAAE,8BAA8B;EACvG,sEAAsE;EACtE,gCAAgC,EAAE,oCAAoC;AACxE;;AAEA;EACE,gCAAgC;EAChC,qFAAqF;EACrF,wCAAwC;EACxC,gCAAgC;EAChC,+CAA+C;EAC/C,UAAU;EACV,wCAAwC;EACxC,+EAA+E;AACjF;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;EACnC;;gDAE8C;EAC9C,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,oCAAoC;IACpC,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA,mCAAmC;AACnC;EACE,qBAAqB,EAAE,qBAAqB;EAC5C,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB,EAAE,gDAAgD;EACpE,aAAa;EACb,sBAAsB;EACtB,sCAAsC,EAAE,yCAAyC;EACjF,2BAA2B,EAAE,qBAAqB;AACpD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,2CAA2C;EAC3C,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,sCAAsC;EACtC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,oDAAoD;AACpD;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA,sDAAsD;AACtD;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA,6CAA6C;AAC7C;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,QAAQ;EACR,QAAQ;EACR,sDAAsD;AACxD;;AAEA;EACE,YAAY,EAAE,0BAA0B;EACxC,gHAAgH;AAClH;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA,6BAA6B;AAC7B;EACE,QAAQ;EACR,SAAS;EACT,wDAAwD;AAC1D;;AAEA;EACE,WAAW,EAAE,2CAA2C;EACxD,kFAAkF;AACpF;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,+CAA+C;EACjD;AACF;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,SAAS;EACT,sDAAsD;AACxD;;AAEA;EACE,WAAW,EAAE,0BAA0B;EACvC,mFAAmF;AACrF;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;AACF","sourcesContent":["/* Import original modal variables and utility styles */\n@import '../components/LoginModal.css';\n\n/* Remove default animation scale translate so it sits perfectly */\n@keyframes cardSlideIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Outer wrapper takes full viewport */\n.auth-page-wrapper {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  background-color: #020617;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n}\n\n.auth-page-wrapper .hyperspeed-bg {\n  position: fixed;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n}\n\n/* Auth card covers the whole page */\n.auth-page-card-container {\n  position: relative;\n  width: 100% !important;\n  max-width: none !important;\n  height: 100% !important;\n  margin: 0 !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  z-index: 10;\n  background: transparent !important;\n  backdrop-filter: none !important;\n}\n\n/* Stretched inner container */\n.auth-page-card-container .auth-container {\n  border: none !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  height: 100% !important;\n  width: 100% !important;\n}\n\n/* Left panel height and styling */\n.auth-page-card-container .auth-left-panel {\n  width: 50% !important; /* Exact half width */\n  height: 100% !important;\n  border-radius: 0 !important;\n  border-right: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.auth-brand-heading-wrapper {\n  position: relative;\n  display: inline-block;\n  margin-bottom: 1.5rem;\n}\n\n.auth-brand-heading-wrapper::before {\n  content: '';\n  position: absolute;\n  top: 15%;\n  left: 10%;\n  right: 10%;\n  bottom: 15%;\n  background: linear-gradient(135deg, #6366f1, #a855f7, #ec4899);\n  filter: blur(35px);\n  opacity: 0.16;\n  z-index: -1;\n  border-radius: 50%;\n  animation: auraPulse 6s ease-in-out infinite alternate;\n  pointer-events: none;\n}\n\n.auth-brand-heading {\n  font-family: 'Outfit', sans-serif !important;\n  font-size: 3.8rem !important;\n  font-weight: 800 !important;\n  line-height: 1.15 !important;\n  letter-spacing: -0.03em !important;\n  background: transparent !important; /* Clear background block completely */\n  text-shadow: 0 4px 20px rgba(99, 102, 241, 0.15) !important;\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important; /* Elastic transition bounce */\n  animation: floatBrandText 5s ease-in-out infinite alternate !important;\n  display: inline-block !important; /* Enable transform/scale features */\n}\n\n.bounce-letter {\n  display: inline-block !important;\n  background: linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%) !important;\n  -webkit-background-clip: text !important;\n  background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n  opacity: 0;\n  transform: translateX(-25px) scale(0.85);\n  animation: letterEmerge 0.65s cubic-bezier(0.25, 1, 0.5, 1) forwards !important;\n}\n\n.auth-brand-heading:hover {\n  transform: scale(1.08) translateY(-4px) !important;\n  filter: brightness(1.25) !important;\n  text-shadow: \n    0 10px 30px rgba(168, 85, 247, 0.45), \n    0 0 50px rgba(99, 102, 241, 0.25) !important;\n  cursor: default;\n}\n\n@keyframes letterEmerge {\n  0% {\n    opacity: 0;\n    transform: translateX(-25px) scale(0.85);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0) scale(1);\n  }\n}\n\n@keyframes floatBrandText {\n  0% {\n    transform: translateY(0) rotate(-1deg);\n  }\n  100% {\n    transform: translateY(-8px) rotate(1deg);\n  }\n}\n\n@keyframes textGradientFlow {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes auraPulse {\n  0% {\n    transform: scale(0.9) rotate(0deg);\n    opacity: 0.16;\n    filter: blur(30px);\n  }\n  100% {\n    transform: scale(1.2) rotate(185deg);\n    opacity: 0.28;\n    filter: blur(45px);\n  }\n}\n\n/* Right panel height and styling */\n.auth-page-card-container .auth-right-panel {\n  width: 50% !important; /* Exact half width */\n  height: 100% !important;\n  border-radius: 0 !important;\n  padding: 6rem 6rem; /* Top/bottom padding provides natural spacing */\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start !important; /* Prevent Flexbox center-scroll cutoff */\n  overflow-y: auto !important; /* Enable scrolling */\n}\n\n.auth-back-btn {\n  position: absolute;\n  top: 30px;\n  left: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.85);\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 10005;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.auth-back-btn:hover {\n  background: rgba(15, 23, 42, 0.9);\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.4);\n  transform: translateX(-4px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);\n}\n\n/* Ensure inside items stretch and align correctly */\n.auth-page-card-container .auth-container {\n  border: none;\n  background: transparent;\n}\n\n/* Custom responsiveness if height needs adjustments */\n@media (max-width: 900px) {\n  .auth-page-wrapper {\n    overflow-y: auto;\n    height: auto;\n    min-height: 100vh;\n  }\n  .auth-page-card-container {\n    height: auto !important;\n  }\n  .auth-page-card-container .auth-container {\n    flex-direction: column;\n    height: auto !important;\n  }\n  .auth-page-card-container .auth-left-panel {\n    width: 100% !important;\n    height: auto !important;\n    padding: 6rem 2rem 3rem;\n  }\n  .auth-page-card-container .auth-right-panel {\n    width: 100% !important;\n    height: auto !important;\n    padding: 3rem 2rem;\n  }\n  .auth-back-btn {\n    top: 20px;\n    left: 20px;\n  }\n}\n\n/* Floating Cloud Logos styling & keyframes */\n.auth-page-card-container .auth-left-panel {\n  position: relative !important;\n  overflow: hidden !important;\n}\n\n.floating-logo {\n  position: absolute;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.floating-logo img {\n  display: block;\n}\n\n/* AWS Logo: Top Left */\n.float-aws {\n  top: 10%;\n  left: 8%;\n  animation: floatAWS 22s infinite ease-in-out alternate;\n}\n\n.float-aws img {\n  width: 100px; /* Optically sized width */\n  filter: invert(1) hue-rotate(180deg) brightness(1.25) opacity(0.55) drop-shadow(0 0 35px rgba(255, 153, 0, 0.7));\n}\n\n@keyframes floatAWS {\n  0% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n  50% {\n    transform: translate(8vw, 6vh) rotate(8deg);\n  }\n  100% {\n    transform: translate(-2vw, 12vh) rotate(-8deg);\n  }\n}\n\n/* Azure Logo: Middle Right */\n.float-azure {\n  top: 38%;\n  right: 6%;\n  animation: floatAzure 26s infinite ease-in-out alternate;\n}\n\n.float-azure img {\n  width: 65px; /* Optically sized width for square block */\n  filter: brightness(1.2) opacity(0.55) drop-shadow(0 0 35px rgba(0, 120, 215, 0.7));\n}\n\n@keyframes floatAzure {\n  0% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n  50% {\n    transform: translate(-8vw, 8vh) rotate(12deg);\n  }\n  100% {\n    transform: translate(-3vw, -8vh) rotate(-12deg);\n  }\n}\n\n/* GCP Logo: Bottom Left */\n.float-gcp {\n  bottom: 12%;\n  left: 10%;\n  animation: floatGCP 24s infinite ease-in-out alternate;\n}\n\n.float-gcp img {\n  width: 85px; /* Optically sized width */\n  filter: brightness(1.2) opacity(0.55) drop-shadow(0 0 35px rgba(66, 133, 244, 0.7));\n}\n\n@keyframes floatGCP {\n  0% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n  50% {\n    transform: translate(8vw, -6vh) rotate(-10deg);\n  }\n  100% {\n    transform: translate(-2vw, -12vh) rotate(8deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
